var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo } from 'react';
import { ClientOnlyContent } from '../../components/atoms/ClientOnlyContent';
import { MainLayout } from '../../components/layouts/MainLayout';
import { useGALeadEvent } from '../../hooks/useGALeadEvent.hook';
import { useScript } from '../../hooks/useScript.hook';
import { useAudienceMarker } from '../../hooks/useAudienceMarker.hook';
import useEmotionStyles from '../../uikit/hooks/useEmotionStyles';
var styles = function () { return ({
    iframe: {
        border: 0,
        width: '100%',
        minHeight: '1200px',
    },
    pixel: {
        height: 1,
        width: 1,
        border: 0,
    },
}); };
function makeUrl(queryParams) {
    var base = 'https://www2.finanzpartnernetz.de/go.cgi';
    var params = new URLSearchParams(queryParams);
    return "".concat(base, "?").concat(params.toString());
}
export var VergleichPage = function () {
    useScript('https://www.vergleich.de/typo3conf/ext/hypo_gridelements/Resources/Public/JavaScript/GridElements/Vergleich/baugeld-container/baugeld-container.js');
    var audienceMarker = useAudienceMarker();
    var commonQueryParams = useMemo(function () { return (__assign({ pid: '17103', wmid: '3582', cpid: '73', prid: '509' }, (audienceMarker !== null && { subid: audienceMarker }))); }, [audienceMarker]);
    var iframeUrl = useMemo(function () {
        return makeUrl(__assign(__assign({}, commonQueryParams), { target: 'iframe_vergleich' }));
    }, [commonQueryParams]);
    var pixelUrl = useMemo(function () {
        return makeUrl(__assign(__assign({}, commonQueryParams), { view: '1' }));
    }, [commonQueryParams]);
    var onLeadCreated = useGALeadEvent();
    var handlePostMessage = useCallback(function (_a) {
        var data = _a.data;
        if (data.type === 'tracking' &&
            data.event === 'Vergleich.de Baufilead' &&
            data.event_category === 'lead') {
            onLeadCreated();
        }
    }, [onLeadCreated]);
    useEffect(function () {
        window.addEventListener('message', handlePostMessage);
        return function onUnmount() {
            window.removeEventListener('message', handlePostMessage);
        };
    }, []);
    var cs = useEmotionStyles(styles);
    return (React.createElement(MainLayout, null,
        React.createElement(ClientOnlyContent, null,
            React.createElement("iframe", { src: iframeUrl, id: "vde-baufinanzierung", className: cs.iframe }),
            React.createElement("img", { src: pixelUrl, className: cs.pixel }))));
};
